module.exports = {"640205001":"育才路街道","640205002":"南街街道","640205003":"中街街道","640205004":"北街街道","640205005":"河滨街道","640205006":"火车站街道","640205100":"红果子镇","640205101":"尾闸镇","640205102":"园艺镇","640205200":"庙台乡","640205201":"礼和乡","640205202":"燕子墩乡","640205401":"简泉农场","640205402":"国营农林牧场","640205403":"良种繁殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640205.json
// module id = 3033
// module chunks = 0